<div class="snackbar__body flex items-center gap-3 rounded-xl border border-l-4 bg-white pl-4 pr-3 py-3.5">
  <mat-icon [svgIcon]="data.icon" class="snackbar__icon size-6! shrink-0"></mat-icon>
  <p class="flex-1 min-w-0 wrap-break-word text-sm font-medium text-ink" [innerHTML]="data.message"></p>
  <button
    (click)="closeSnackBar()"
    class="flex shrink-0 items-center justify-center bg-transparent border-none outline-none outline-0 focus:outline-none focus:border-none cursor-pointer"
    type="button"
  >
    <mat-icon svgIcon="close" class="size-2.5! shrink-0"></mat-icon>
  </button>
</div>
